<!--
  查题库详情页：搜索 + 面包屑 + 单题作答（按 questionType 切换题型组件）+ 提交结果
-->
<template>
    <div class="topic">
        <studySearch ref="studySearch"  
        :hotwordList="hotwordList" 
        :sourceType="'topic'"
        @searchClick="searchClick"></studySearch>
        <div class="topic-cont">
            <div class="cont-tit">查题库</div>
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb"> 
                <el-breadcrumb-item>{{firstClassification?firstClassification:'全部'}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{secondClassification?secondClassification:'' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="topic-list" v-if="listInfo.length!=0">
                <div v-if="topicId==''" class="list-num">第 <span class="num-index">{{ pageInfo.pageNum }}</span>/{{ pageInfo.total }}题</div>
                <div
                    v-for="(item, index) in displayList"
                    class="topic-item"
                    :key="item.id || index"
                >
                    <!-- 选项区：1/3/10 单选类 2/11/12 多选 4 填空 5～9/13 简答类（此处示例只渲染常见编码） -->
                    <div class="item-content" >
                        <!-- 单选，判断 ,病案单选题,多选K型题-->
                        <topic-answer-single
                            v-if="currentItem.questionType == 1 || currentItem.questionType == 3 || currentItem.questionType == 10 || currentItem.questionType == 11"
                            :item="currentItem"
                            @submitAnswer="submitAnswer"
                        />
                        <!-- 多选， -->
                        <TopicAnswerMultiple
                            @submitAnswer="submitAnswer"
                            v-else-if="currentItem.questionType == 2"
                            :item="currentItem"
                        > </TopicAnswerMultiple>
                        <!-- 填空,名词解释,论述题,简答题,病案分析题,经义阐释题 -->
                        <TopicAnswerFill
                            @submitAnswer="submitAnswer" 
                            v-else-if="currentItem.questionType >= 4 && currentItem.questionType <= 9" 
                            :item="currentItem" >
                        </TopicAnswerFill>

                        <!-- <topic-answer-essay
                            v-else-if="[ 13].indexOf(Number(currentItem.questionType)) !== -1"
                            :item="currentItem"
                        /> -->
                        <!-- 组合选择题 --> 
                        <TopicCombinationChoice  v-else-if="currentItem.questionType == 12||currentItem.questionType == 14" 
                            :item="currentItem" 
                            @submitAnswer="submitAnswer"
                        > </TopicCombinationChoice>
                        <!-- 病案分析选择题 -->
                        <!-- <topic-answer-single
                            v-else-if="currentItem.questionType == 14" 
                            :item="currentItem"
                            @submitAnswer="submitAnswer"
                        /> -->
                    </div> 
                    <!-- 提交后：答题结果 -->
                    <div v-if="showBottomPanel" >
                        <!-- 组合选择题（12）在每道子题下方已展示结果，此处不再重复 -->
                        <div class="result-panel" v-if="currentItem.questionType != 12&&currentItem.questionType!= 14">
                            <template >
                                <div class="result-row user-row" v-if="answerInfo.inputAnswer">
                                    <span class="result-label">您的答案：</span>
                                    <span class="user-answer-text">{{ answerInfo.inputAnswer||'未填写' }}</span> 
                                    <i class="result-icon " 
                                    :class="{'correct el-icon-success': answerInfo.isCorrect, 'wrong el-icon-circle-close': !answerInfo.isCorrect}"></i>
                                </div>
                                <div class="result-row ref-row" v-if="answerInfo.correctAnswer">
                                    <span class="result-label">参考答案：</span>
                                    <span class="ref-answer-text" v-html="answerInfo.correctAnswer  "></span>
                                </div>
                                <div v-if="answerInfo.analysis" class="result-analysis">{{ answerInfo.analysis }}</div>
                            </template>
                        </div>
                        <!-- 上一题 / 下一题 -->
                        <div class="topic-nav" v-if="topicId==''">
                            <el-button plain :disabled="pageInfo.pageNum <= 1" @click="prevQuestion">上一题</el-button>
                            <el-button
                                type="success" 
                                :disabled="pageInfo.pageNum >= pageInfo.total"
                                @click="nextQuestion"
                            >
                                下一题
                            </el-button>
                        </div>
                    </div>
                   
                </div>
                
            </div>
            <div class="topic-empty" v-else>暂无相关题目数据～</div>
        </div>
    </div>
</template>

<script>
/**
 * 查题库页：questionList 拉题；路由 query 含 firstClassification、secondClassification。
 * 二级分类可与 QUESTION_TYPE_OPTIONS.label 匹配得到请求用 questionType。
 */
import studySearch from './comps/study_search.vue';
import TopicAnswerSingle from './topicInfo/TopicAnswerSingle.vue';
import TopicAnswerMultiple from './topicInfo/TopicAnswerMultiple.vue';
import TopicAnswerFill from './topicInfo/TopicAnswerFill.vue';
import TopicCombinationChoice from './topicInfo/TopicCombinationChoice.vue'; 
import {
    getQuestionTypeLabel, 
    QUESTION_TYPE_OPTIONS,
} from './topicInfo/topicQuestionTypes.js';
import { questionList,confirmAnswer } from '../../io/api';

export default {
    components: {
        studySearch,
        TopicAnswerSingle,
        TopicAnswerMultiple,
        TopicAnswerFill,
        TopicCombinationChoice, 
    },
    computed: {
        currentItem() {
            return this.listInfo.length ? this.listInfo[0] : null;
        },
        displayList() {
            if (this.listInfo.length > 1) return this.listInfo;
            return this.currentItem ? [this.currentItem] : [];
        },
        /** 底部结果区（含翻题）：组合题需全部子题提交后；其它题型需有参考答案 */
        showBottomPanel() {
            const item = this.currentItem;
            if (!item) return false;
            // 如果需要需全部子题提交后，显示上/下题，放开以下判断
            // if (item.questionType== 12||item.questionType== 14) {
            //     return this.combinationAllDone;
            // }
            return !!(this.answerInfo && this.answerInfo.correctAnswer);
        },
    },
    data () {
        return {
            searchVal:this.$route.query.searchWord||'',
            subType:this.$route.query.subType||1,
            /** 一级分类（题目来源 questionSource） */
            firstClassification:this.$route.query.firstClassification||'',
            secondClassification:this.$route.query.secondClassification||'',
            /** 请求列表时的题型编码，来自路由二级分类与 QUESTION_TYPE_OPTIONS 匹配 */
            questionType:'',
            topicId:this.$route.query.topicId||'',//topicId有值代表检索页过来的，则不显示第几题和上下题
 
            hotwordList: [
                { val: '孙思邈' },
                { val: '金匮要略' },
                { val: '伤寒论' },
                { val: '钱乙' }, 
            ],
            listInfo:[],
            /** 答案信息 */
            answerInfo:{
                analysis: '',   //参考答案
                correctAnswer: '', //正确答案
                inputAnswer: '', //用户答案
                isCorrect: false, //是否正确
                tip: '', //提示
            },
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            QUESTION_TYPE_OPTIONS,
            /** 组合题：是否已提交完 questionMapList 中全部子题 */
            combinationAllDone: false,
        }
    }, 
    created() {
        // 二级分类：若与题型表 label 一致，则解析出 questionType 供 getList 使用
        const sc = this.$route.query.secondClassification;
        if (sc !== undefined && sc !== null && sc !== '') { 
            const info = this.QUESTION_TYPE_OPTIONS.find(
                (item) => String(item.label) == String(sc)
            );
            if (info) {
                this.questionType = info.type;
            } 
        }
    },
    mounted(){
        this.getList(1);
        
    }, 
    methods: {
        setQuestionType: getQuestionTypeLabel,
        //检索
        searchClick(){ 
            let url = this.$router.resolve({ 
                path: '/studyTopicDetails', 
                query:{
                    searchWord:this.$store.state.study.searchVal,
                    subType:'topic',
                }
             })
            this.$windowOpen({ url: url.href, isLogin: true })
        }, 
        submitAnswer(params) {
            // combination，说明是组合题的子题提交， 
            if (params.combination) {
                this.answerInfo = params.data || {};
                this.combinationAllDone = !!params.allSubmitsDone;
                return;
            }
            // 其它题型：提交答案，并更新组合题状态
            const { allSubmitsDone, ...apiParams } = params;
            confirmAnswer(apiParams).then((res) => {
                let { code, data, msg } = res.data;
                if (code == 0) {
                    this.answerInfo = data;
                    if (
                        this.currentItem &&
                        Number(this.currentItem.questionType) === 12
                    ) {
                        this.combinationAllDone = !!allSubmitsDone;
                    } else {
                        this.combinationAllDone = false;
                    }
                } else {
                    this.$message.error(msg || '提交失败～');
                }
            });
        },
        prevQuestion() {
            this.answerInfo = {};
            this.combinationAllDone = false;
            if (this.pageInfo.pageNum > 1) {
                this.changePage(this.pageInfo.pageNum - 1);
            }
        },
        nextQuestion() {
            this.answerInfo = {};
            this.combinationAllDone = false;
            if (this.pageInfo.pageNum < this.pageInfo.total) {
                this.changePage(this.pageInfo.pageNum + 1);
            }
        },  
        /** 拉取题目列表（每次 1 条） */
        getList(num){ 
            this.searchVal=this.$store.state.study.searchVal;
            let params={
                page: num?num:this.pageInfo.pageNum,
                limit: 1,
                questionSource:this.firstClassification,//题目来源
                questionType:this.questionType||'',//题目类型 对应topicQuestionTypes.js里
                id:this.topicId
            }; 
            questionList(params).then(res=>{
                let {code,data,msg}=res.data;
                if(code==0){
                    if(data.list ){
                        this.listInfo = data.list || [];
                        this.answerInfo = {};
                        this.combinationAllDone = false;
                        this.pageInfo.pageNum = num ? num : this.pageInfo.pageNum;
                        this.pageInfo.total=data.total||0;
                    }else{
                        if(this.searchVal==''){
                            window.open(data,'_self');
                            return;
                        } 
                    }
                }else{
                    this.$message.error(msg||'请求失败～');
                }
            })
        },
        changePage(num){
            this.pageInfo.pageNum=num;
            this.getList(num);
        },
        //banner检索
        banner_search(val){ 
            this.searchVal=val;
            this.getList(1);
            // this.getTree();
        }, 
        toPage(item){    
            let url= this.$router.resolve({
                path:'/studyDetails',  
                query:{

                },
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} )
        }, 
 
    } 
}
</script>

<style lang="less" scoped>
.topic{ 
    .topic-cont{
        width: 1200px;
        margin: 40px auto;
        ::v-deep .el-breadcrumb{
            margin-bottom: 30px;
            font-size: 16px;  
            font-weight: bold;
            .el-breadcrumb__inner{
                color: #386DE8;
            } 
        }
        .cont-tit{
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #303133;
            text-align: center;
        }
        .topic-list{
            width: 100%;
            min-height: 300px;
            // border: 1px solid #386DE8;
            background: #F1F5FE;
            border-radius: 10px;
            box-shadow: 0px 3px 12px 0px #d3d8dc;
            padding: 24px;
            box-sizing: border-box;
            .list-num{
                text-align: center;
                font-size: 20px;
                color: #303133;
                margin-bottom: 20px;
                .num-index{
                    color: #386DE8;
                    font-weight: bold;
                }
            }
            .topic-item{
                padding-bottom: 32px;
                margin-bottom: 32px;
                border-bottom: 1px solid #E4E7ED;
                &:last-child{
                    border-bottom: none;
                    margin-bottom: 0;
                    padding-bottom: 0;
                }
                .item-label{
                    display: flex;
                    align-items: flex-start;
                    flex-wrap: wrap;
                    gap: 12px 16px;
                    margin-bottom: 20px;
                    line-height: 1.7;
                    .label-type{
                        flex-shrink: 0;
                        display: inline-block;
                        padding: 2px 10px;
                        font-size: 14px;
                        font-weight: bold;
                        color: #fff;
                        background: #386DE8;
                        border-radius: 2px;
                    }
                    .label-tit{
                        flex: 1;
                        min-width: 200px;
                        font-size: 16px;
                        color: #303133;
                    }
                }
                .item-content{
                    padding-left: 0;
                }
                
                .result-panel{
                    margin-top: 20px;
                    padding: 20px 24px;
                    background: #E8F2FF;
                    border: 1px solid #C0D9F6;
                    border-radius: 4px;
                    .result-row{
                        display: flex;
                        align-items: flex-start;
                        // flex-wrap: wrap;
                        margin-bottom: 12px;
                        font-size: 15px;
                        line-height: 1.8;
                        &.user-row{
                            align-items: center;
                        }
                        .result-label{
                            flex-shrink: 0;
                            color: #303133;
                            font-weight: bold;
                            margin-right: 8px;
                        }
                        .user-answer-text{
                            color: #386DE8;
                            font-weight: bold;
                            margin-right: 8px;
                        }
                        .ref-answer-text{
                            color: #67C23A;
                            font-weight: bold;
                        }
                        .result-icon{
                            font-size: 1.2em;
                            &.correct{
                                color: #67C23A;
                            }
                            &.wrong{
                                color: #F56C6C;
                            }
                        }
                    }
                    .result-analysis{
                        margin-top: 6px;
                        padding: 12px 0 0;
                        border-top: 1px dashed #B3D4FC;
                        font-size: 14px;
                        color: #606266;
                        line-height: 1.8;
                        text-indent: 0;
                    }
                    .result-actions{
                        display: flex;
                        justify-content: flex-end;
                        gap: 24px;
                        margin-top: 16px;
                        padding-top: 12px;
                        .action-link{
                            cursor: pointer;
                            font-size: 14px;
                            color: #386DE8;
                            i{
                                margin-right: 4px;
                            }
                            &:hover{
                                opacity: 0.85;
                            }
                        }
                    }
                }
                .topic-nav{
                    display: flex;
                    // justify-content: space-between;
                    justify-content: flex-end;
                    align-items: center;
                    margin-top: 24px;
                    gap: 16px;
                    .btn-next{
                        flex: 1;
                        max-width: none;
                    }
                }
            }
            
        }
    }
    .tit{
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 30px;
    }  
    .topic-empty{
        text-align: center;
        padding: 80px 0;
        color: #909399;
        font-size: 16px;
    }
}
</style>